import { QcResultsComponent } from './components/qc-results/qc-results.component';
import { QcService } from './services/qc.service';

export const COMPONENTS = [QcResultsComponent];

export const SERVICES = [QcService];
